import ExcelJS from 'exceljs/dist/exceljs.min.js';

const COLOR_PRIMARIO = 'FF20453D';
const COLOR_ENCABEZADO_TABLA = 'FFF3F4F6';
const FORMATO_MONTO = '"RD$" #,##0.00';
const FORMATO_FECHA = 'dd/mm/yyyy';

const ETIQUETAS_TIPO = { factura: 'Factura', pago: 'Pago', nota_credito: 'Nota de Crédito' };

async function descargarWorkbook(workbook, nombreArchivo) {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombreArchivo;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

const fecha = (valor) => (valor ? new Date(valor) : null);

function agregarHoja(workbook, nombre, columnas, filas) {
  const hoja = workbook.addWorksheet(nombre);
  hoja.columns = columnas.map(c => ({ header: c.titulo, key: c.clave, width: c.ancho, style: c.formato ? { numFmt: c.formato } : {} }));
  const encabezado = hoja.getRow(1);
  encabezado.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  encabezado.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: COLOR_PRIMARIO } };
  filas.forEach(f => hoja.addRow(f));
  hoja.views = [{ state: 'frozen', ySplit: 1 }];
  return hoja;
}

/**
 * Genera y descarga el estado de cuenta de un cliente en Excel a partir de
 * la respuesta de GET /api/reporte/estado-cuenta-cliente/:id_entidad_cliente.
 */
export default async function generarExcelEstadoCuentaCliente(datos) {
  if (!datos) return;
  const workbook = new ExcelJS.Workbook();
  workbook.creator = 'OmniERP';
  workbook.created = new Date();

  const { cliente, resumen } = datos;
  const hojaResumen = workbook.addWorksheet('Resumen');
  hojaResumen.columns = [{ width: 32 }, { width: 24 }];
  hojaResumen.addRow(['Estado de Cuenta de Cliente']).font = { bold: true, size: 14 };
  hojaResumen.addRow(['Cliente', cliente.razon_social]);
  hojaResumen.addRow(['RNC/Cédula', cliente.rnc || cliente.cedula || '']);
  hojaResumen.addRow(['Generado', new Date().toLocaleDateString('es-DO')]);
  hojaResumen.addRow([]);
  [
    ['Total Facturado', resumen.total_facturado],
    ['Total Pagado', resumen.total_pagado],
    ['Total Notas de Crédito', resumen.total_notas_credito],
    ['Balance Pendiente', resumen.total_pendiente],
    ['Balance Vencido', resumen.total_vencido]
  ].forEach(([titulo, valor]) => {
    const fila = hojaResumen.addRow([titulo, valor]);
    fila.getCell(2).numFmt = FORMATO_MONTO;
    fila.getCell(1).font = { bold: true };
  });

  agregarHoja(workbook, 'Facturas', [
    { titulo: 'Factura', clave: 'documento', ancho: 22 },
    { titulo: 'Fecha', clave: 'fecha', ancho: 14, formato: FORMATO_FECHA },
    { titulo: 'Vencimiento', clave: 'vence', ancho: 14, formato: FORMATO_FECHA },
    { titulo: 'Total', clave: 'total', ancho: 16, formato: FORMATO_MONTO },
    { titulo: 'Balance', clave: 'balance', ancho: 16, formato: FORMATO_MONTO },
    { titulo: 'Estado', clave: 'estado', ancho: 14 }
  ], datos.facturas.map(f => ({
    documento: f.ncf || `Factura #${f.id_factura}`,
    fecha: fecha(f.fecha),
    vence: fecha(f.fecha_vencimiento),
    total: f.monto_total,
    balance: f.balance,
    estado: f.estado_vencimiento === 'vencida' ? 'vencida' : f.estado_pago
  })));

  agregarHoja(workbook, 'Movimientos', [
    { titulo: 'Fecha', clave: 'fecha', ancho: 14, formato: FORMATO_FECHA },
    { titulo: 'Tipo', clave: 'tipo', ancho: 16 },
    { titulo: 'Documento', clave: 'documento', ancho: 40 },
    { titulo: 'Cargo', clave: 'cargo', ancho: 16, formato: FORMATO_MONTO },
    { titulo: 'Abono', clave: 'abono', ancho: 16, formato: FORMATO_MONTO },
    { titulo: 'Balance', clave: 'balance', ancho: 16, formato: FORMATO_MONTO }
  ], datos.movimientos.map(m => ({
    fecha: fecha(m.fecha),
    tipo: ETIQUETAS_TIPO[m.tipo] || m.tipo,
    documento: m.documento,
    cargo: m.cargo,
    abono: m.abono,
    balance: m.balance
  })));

  agregarHoja(workbook, 'Antigüedad', [
    { titulo: 'Rango', clave: 'rango', ancho: 20 },
    { titulo: 'Facturas', clave: 'cantidad', ancho: 12 },
    { titulo: 'Monto', clave: 'total', ancho: 16, formato: FORMATO_MONTO }
  ], datos.antiguedad_cartera);

  const nombre = cliente.razon_social.replace(/\s+/g, '-');
  await descargarWorkbook(workbook, `estado-cuenta_${nombre}_${new Date().toISOString().slice(0, 10)}.xlsx`);
}
